// extracted by mini-css-extract-plugin
export default {"smpcList":"style-module--smpcList--79b2e","list":"style-module--list--44b4d","small_margin":"style-module--small_margin--136bc","top-spacing":"style-module--top-spacing--e9cdb"};